var uploadedLists;
var checked = false;

function GetUploadedLists() {
    $('.suppression-lists-error').html('');
    jQuery.DotComAjax({
        url: "/Ajax/GetUploadedLists",
        cache: false,
        dataType: 'json',
        type: 'get',
        success: function (data) {
            if (data) {
                uploadedLists = data;
                $.when(searchButtonClick(), ReadSelections()).done(function(x) {                    
                    $('.suppression-lists table').show();
                    SetExcludeUploadEvents();
                });                         
            }
        },
        error: function (jqXHR, textStatus, errors) {
            $('.suppression-lists-error').html('Unable to get uploaded suppression lists.');
        },
        complete: function () {
            $('.suppression-lists img').hide();
        }
    });
}

function SetExcludeUploadEvents() {
    jQuery('.upload-search-container img').click(function () {
        var searchText = jQuery('.searchText').val();
        searchButtonClick(searchText);
    });

    jQuery('.upload-search-container input:checkbox').click(function (e) {
        if ($(this).is(':checked')) {
            jQuery('#suppression-lists-table input:checkbox').prop('checked', true);
        } else {
            jQuery('#suppression-lists-table input:checkbox').prop('checked', false);
        }       
    });

    jQuery('#suppression-lists-table input:checkbox').click(function (e) {
        if ($(this).is(':checked')) {
            if ($('#suppression-lists-table input:checkbox:not(:checked)').length > 0) {
                jQuery('.upload-search-container input:checkbox').prop('checked', false);
            } else {
                jQuery('.upload-search-container input:checkbox').prop('checked', true);
            }
        }
        else {
            jQuery('.upload-search-container input:checkbox').prop('checked', false);
        }
    });

    jQuery('.upload-search-container input:text').keydown(function (e) {
        if ((e.which == 13) || (e.keyCode == 13)) {
            var searchText = jQuery('.searchText').val();
            searchButtonClick(searchText);
            e.preventDefault();
        }
        });

    jQuery('#UpdateExcludeLists').click(function(e) {
        $('.suppression-lists-error').html('');
        var checkedLists = new Array();
        var rows = jQuery('#suppression-lists-table .gridrow');
        for (var i = 0; i < rows.length; i++) {
            if(jQuery(rows[i]).find('.chk').is(':checked'))
                checkedLists.push(jQuery(rows[i]).attr('data_custId'));
                }

        if (checkedLists.length > 0 && !checked) {
            e.preventDefault();
            jQuery.ajax({
            url: "/Ajax/SaveCheckedUploadedLists",
            cache: false,
            data: JSON.stringify({ customerIds: checkedLists }),
            type: 'post',
            contentType: 'application/json',
            dataType : 'json',
            success: function () {
                checked = true;
                jQuery('#UpdateExcludeLists').trigger('click');
                return true;
                },
            error: function (jqXHR, textStatus, errors) {
                $('.suppression-lists-error').html('Unable to exclude uploaded lists.');
                return false;
                }
            });
        }
        else {
            return true;
        }
    });
}

function searchButtonClick(searchText) {
    var list = [];
    jQuery('.upload-search-container input:checkbox').prop('checked', false);
    if (uploadedLists) {
        if (typeof (searchText) === 'undefined' || searchText === "") {
            jQuery('#suppression-lists-table tbody .gridrow').remove();
            generateTable(uploadedLists);
        } else {
            for (var i = 0; i < uploadedLists.length; i++) {
                if (uploadedLists[i].ListName.toUpperCase().includes(searchText.toUpperCase())) {
                    list.push(uploadedLists[i]);
                }
            }
            jQuery('#suppression-lists-table tbody .gridrow').remove();
            generateTable(list);
        }
    }
}

function generateTable(lists) {
    var recordNumber = 0;

    for (var i = 0; i < lists.length; i++) {
        recordNumber = recordNumber + 1;
        var row = document.createElement('tr');
        row.className = 'gridrow';
        row.setAttribute('data_custId', lists[i].MmdbBitsetLabel);
        row.style.backgroundColor = (recordNumber % 2 == 1) ? '#FFFFFF' : '#E1EBF4';
        row.style.height = '20px';

        var td = document.createElement('td');
        td.className = 'gridcell';
        var recordNumberNode = document.createTextNode(recordNumber);
        td.appendChild(recordNumberNode);

        var td1 = document.createElement('td');
        td1.className = 'gridcell';

        var chkbox = document.createElement('input');
        chkbox.type = "checkbox";
        chkbox.className = "chk";
        chkbox.name = "chk";
        td1.appendChild(chkbox);

        var td2 = document.createElement('td');
        td2.className = 'gridcell listName';
        var listNameNode = document.createTextNode(lists[i].ListName);
        td2.appendChild(listNameNode);

        var td3 = document.createElement('td');
        td3.className = 'gridcell';
        var matchedCountNode = document.createTextNode(lists[i].NumberRecordsMatched);
        td3.appendChild(matchedCountNode);

        var td4 = document.createElement('td');
        td4.className = 'gridcell';
        var uploadedCountNode = document.createTextNode(lists[i].NumberRecordsUploaded);
        td4.appendChild(uploadedCountNode);

        var td5 = document.createElement('td');
        td5.className = 'gridcell custId';
        td5.style.display = 'none';
        var bitsetLabelNameNode = document.createTextNode(lists[i].MmdbBitsetLabel);
        td5.appendChild(bitsetLabelNameNode);

        var td6 = document.createElement('td');
        td6.className = 'gridcell listId';
        td6.style.display = 'none';
        var listIdNode = document.createTextNode(lists[i].ListId);
        td6.appendChild(listIdNode);

        //Add td's into a row
        row.appendChild(td);
        row.appendChild(td1);
        row.appendChild(td2);
        row.appendChild(td3);
        row.appendChild(td4);
        row.appendChild(td5);
        row.appendChild(td6);

        jQuery('#suppression-lists-table tbody').append(row);
    }
}

function ReadSelections() {
    var customerIds = [];    

    var rows = jQuery('#suppression-lists-table .gridrow');
    for (var i = 0; i < rows.length; i++) {        
        customerIds.push(jQuery(rows[i]).attr('data_custId'));
    }

    if (customerIds.length > 0) {
        jQuery.ajax({
            url: "/Ajax/ReadSelections",
            cache: false,
            data: JSON.stringify({ customerIds: customerIds }),
            type: 'post',
            dataType: 'json',
            contentType: 'application/json',
            success: function (data) {               
                for (var d = 0; d < data.length; d++) {
                    $("#suppression-lists-table").find("[data_custid='" +data[d]+ "']").find('input:checkbox').prop('checked', true);
                }                
                return true;
            },
            error: function (jqXHR, textStatus, errors) {
                 $('.suppression-lists-error').html('Unable to get uploaded lists.');
                return false;
            }
        });
    }
}


